<div>
  <!-- form -->
  <form>
    <div>
      <div class="row tw-mt-8 px-2">
        <!--phonebook title-->
        <div class="md:tw-w-1/2">
          <form-field-searcher
            type="text"
            fieldName="name"
            label="common.name"
            [control]="form?.get('name')"
            (comparisonObjectChanges)="getComparisonObject($event)"
          >
          </form-field-searcher>
        </div>

        <!--contact count-->
        <div class="md:tw-w-1/2">
          <form-field-searcher
            type="text"
            fieldName="contactsCount"
            label="common.contactsCount"
            type="number"
            [hasSeparator]="false"
            [control]="form?.get('contactsCount')"
            (comparisonObjectChanges)="getComparisonObject($event)"
          >
          </form-field-searcher>
        </div>

        <!--type-->
        <div class="md:tw-w-1/2">
          <form-field-searcher
            [control]="form?.get('type')"
            type="enum"
            fieldName="phonebookTypes"
            label="common.type"
            enumName="PhonebookTypes"
            (comparisonObjectChanges)="getComparisonObject($event)"
          >
          </form-field-searcher>
        </div>

        <!--submit-->
        <div class="md:tw-w-1/2">
          <button
            type="button"
            (click)="onSubmit()"
            [themeColor]="'btn-info'"
            mat-ripple
            class="btn btn-hover-rise button-shadow flex-center tw-mt-2.5 tw-mb-1 tw-w-full tw-max-w-[120px]"
          >
            <i
              class="mx-1 mdi mdi-26px mdi-account-search-outline !tw-pb-1.5"
            ></i>
            <span class="!tw-text-[16px]">
              {{ "common.search" | translate }}</span
            >
          </button>
        </div>
      </div>
    </div>

    <div class="app-phonebook">
      <app-dynamic-table
        [config]="pageConfig?.tableConfig"
        [config]="pageConfig.tableConfig"
        [loading]="pageConfig.loading"
        [isEmpty]="pageConfig?.isEmpty"
        [hasError]="pageConfig?.hasError"
        (sortObject)="getSortItems($event)"
        (comparisonObjects)="getComparisonObjects($event)"
        (pageNumber)="changePageNumber($event)"
        (pageSize)="changePageSize($event)"
        (onSelectAll)="onSelectAll($event)"
      >
        <ng-container table-body *ngIf="items && !pageConfig.loading">
          <ng-container *ngFor="let item of items; let i = index">
            <!--* level 1 -->
            <tr
              [level]="1"
              class="tw-cursor-pointer"
              phonebook-row
              [ngClass]="{ 'row-active': item.id == selectedPhonebook.id }"
              [phonebook]="item"
              [checked]="item.checked || false"
              [phonebookRecipients]="phonebookRecipients"
              [PhonebookTypesEnumValues]="PhonebookTypesEnumValues"
              [isShowParentBtn]="false"
              [isShowInputs]="isShowInputs"
              [isShowFullTable]="isShowFullTable"
              (operation)="onOperation($event, item)"
              (select)="onSelect($event)"
              (changeState)="onChangeState($event)"
            ></tr>
          </ng-container>
        </ng-container>
      </app-dynamic-table>
    </div>
  </form>
</div>
